<template>
  <v-container id="clientAboutSurvey" class="pa-0 pb-5">
    <v-progress-linear class="ma-0" v-if="isAllLoading" indeterminate color="blue"></v-progress-linear>
    <v-card flat max-width="600" class="mx-auto">
      <v-form v-show="!isAllLoading" ref="form" v-model="form.valid">
        <v-list class="pa-2">
          <ClientAboutBasicSex class="abt-item px-3" ref="sex"
            :status="getStatus"
            :data="getData"
            @emit="emitted"></ClientAboutBasicSex>
          <ClientAboutBasicBirthday class="abt-item px-3" ref="birthday"
            :status="getStatus"
            :data="getData"
            @emit="emitted"></ClientAboutBasicBirthday>
          <v-subheader class="abt-item px-3">住まい</v-subheader>
          <v-divider class="abt-item px-3"></v-divider>
          <ClientAboutBasicHome v-for="item in getAddressItems" class="abt-item px-3" ref="address"
            :key="item.id"
            :status="getStatus"
            :data="item"
            @emit="emitted"></ClientAboutBasicHome>
          <ClientAboutBasicHomeInsert class="abt-item mb-3 blue--text text--darken-2" @emit="emitted"></ClientAboutBasicHomeInsert>
          <v-subheader class="abt-item px-3">連絡先</v-subheader>
          <v-divider class="abt-item px-3"></v-divider>
          <ClientAboutBasicContact v-for="item in getContactItems" class="abt-item px-3" ref="contact"
            :key="item.id"
            :status="getStatus"
            :data="item"
            @emit="emitted"></ClientAboutBasicContact>
          <ClientAboutBasicContactInsert class="abt-item mb-3 blue--text text--darken-2" @emit="emitted"></ClientAboutBasicContactInsert>
          <v-divider class="abt-item px-3"></v-divider>
          <ClientAboutSurveyJobs class="abt-item px-3" ref="jobs"
            :status="getStatus"
            :data="getData"
            @emit="emitted"></ClientAboutSurveyJobs>
          <ClientAboutSurveyGoals class="abt-item px-3" ref="goals"
            :status="getStatus"
            :data="getData"
            @emit="emitted"></ClientAboutSurveyGoals>
          <ClientAboutSurveyLocations class="abt-item px-3" ref="locations"
            :status="getStatus"
            :data="getData"
            @emit="emitted"></ClientAboutSurveyLocations>
          <ClientAboutSurveyTime class="abt-item px-3" ref="time"
            :status="getStatus"
            :data="getData"
            @emit="emitted"></ClientAboutSurveyTime>
          <ClientAboutSurveyStays class="abt-item px-3" ref="stays"
            :status="getStatus"
            :data="getData"
            @emit="emitted"></ClientAboutSurveyStays>
          <ClientAboutBasicNotes class="abt-item px-3" ref="notes"
            :status="getStatus"
            :data="getData"
            @emit="emitted"></ClientAboutBasicNotes>
          <v-subheader class="abt-item px-3">渡航歴</v-subheader>
          <v-divider class="abt-item px-3"></v-divider>
          <ClientAboutBackgroundsTravel v-for="item in getTravelItems" :key="item.id" class="abt-item my-3" ref="travel"
            :status="getStatus"
            :data="item"
            @emit="emitted"></ClientAboutBackgroundsTravel>
          <ClientAboutBackgroundsTravelInsert class="abt-item mb-3 blue--text text--darken-2" @emit="emitted"></ClientAboutBackgroundsTravelInsert>
          <v-subheader class="abt-item px-3">語学資格</v-subheader>
          <v-divider class="abt-item px-3"></v-divider>
          <ClientAboutBackgroundsCert v-for="item in getCertItems" :key="item.id" class="abt-item my-3" ref="cert"
            :status="getStatus"
            :data="item"
            @emit="emitted"></ClientAboutBackgroundsCert>
          <ClientAboutBackgroundsCertInsert class="abt-item mb-3 blue--text text--darken-2" @emit="emitted"></ClientAboutBackgroundsCertInsert>
          <ClientAboutSurveyLang class="abt-item px-3" ref="lang"
            :status="getStatus"
            :data="getData"
            @emit="emitted"></ClientAboutSurveyLang>
          <ClientAboutSurveyPreferences class="abt-item px-3" ref="preferences"
            :status="getStatus"
            :data="getData"
            @emit="emitted"></ClientAboutSurveyPreferences>
          <ClientAboutSurveyBudget class="abt-item px-3" ref="budget"
            :status="getStatus"
            :data="getData"
            @emit="emitted"></ClientAboutSurveyBudget>
          <ClientAboutSurveyKnows class="abt-item px-3" ref="knows"
            :status="getStatus"
            :data="getData"
            @emit="emitted"></ClientAboutSurveyKnows>
          <ClientAboutSurveyWants class="abt-item px-3" ref="wants"
            :status="getStatus"
            :data="getData"
            @emit="emitted"></ClientAboutSurveyWants>
        </v-list>
      </v-form>
    </v-card>
  </v-container>
</template>

<script>
import ClientAboutBasicSex from '../basic/components/sex'
import ClientAboutBasicBirthday from '../basic/components/birthday'
import ClientAboutBasicHome from '../basic/components/home'
import ClientAboutBasicHomeInsert from '../basic/components/home/modals/insert'
import ClientAboutBasicContact from '../basic/components/contact'
import ClientAboutBasicNotes from '../basic/components/notes'
import ClientAboutBasicContactInsert from '../basic/components/contact/modals/insert'
import ClientAboutBackgroundsTravel from '../backgrounds/components/travel'
import ClientAboutBackgroundsTravelInsert from '../backgrounds/components/travel/modals/insert'
import ClientAboutBackgroundsCert from '../backgrounds/components/cert'
import ClientAboutBackgroundsCertInsert from '../backgrounds/components/cert/modals/insert'
import ClientAboutSurveyJobs from './components/jobs'
import ClientAboutSurveyGoals from './components/goals'
import ClientAboutSurveyLocations from './components/locations'
import ClientAboutSurveyTime from './components/time'
import ClientAboutSurveyStays from './components/stays'
import ClientAboutSurveyLang from './components/lang'
import ClientAboutSurveyPreferences from './components/preferences'
import ClientAboutSurveyBudget from './components/budget'
import ClientAboutSurveyKnows from './components/knows'
import ClientAboutSurveyWants from './components/wants'
const DEFAULT = {
  STATUS: {
    LOADING: 'all',
    EDITING: '',
    SUBMITTING: ''
  },
  FORM: {
    ITEM: {
      DEFAULT: JSON.stringify({
        value: '',
        required: false
      }),
      REQUIRED: JSON.stringify({
        value: '',
        required: true
      })
    }
  }
}
export default {
  name: 'clientAboutSurvey',
  components: {
    ClientAboutBasicSex,
    ClientAboutBasicBirthday,
    ClientAboutBasicHome,
    ClientAboutBasicHomeInsert,
    ClientAboutBasicContact,
    ClientAboutBasicContactInsert,
    ClientAboutBasicNotes,
    ClientAboutBackgroundsTravel,
    ClientAboutBackgroundsTravelInsert,
    ClientAboutBackgroundsCert,
    ClientAboutBackgroundsCertInsert,
    ClientAboutSurveyJobs,
    ClientAboutSurveyGoals,
    ClientAboutSurveyLocations,
    ClientAboutSurveyTime,
    ClientAboutSurveyStays,
    ClientAboutSurveyLang,
    ClientAboutSurveyPreferences,
    ClientAboutSurveyBudget,
    ClientAboutSurveyKnows,
    ClientAboutSurveyWants
  },
  data () {
    return {
      config: {
        status: {
          loading: DEFAULT.STATUS.LOADING,
          editing: DEFAULT.STATUS.EDITING
        }
      },
      form: {
        valid: true
      },
      store: {
      }
    }
  },
  created () {
  },
  mounted () {
    this.init()
  },
  methods: {
    init: function () {
      this.$nextTick(() => {
        this.get()
      })
    },
    get: function (type) {
      this.$set(this.config.status, 'loading', type != null ? type : 'all')
      this.$emit('emit', {
        action: 'state',
        data: {
          type: 'loading',
          status: true
        }
      })
      this.$firebase.auth().currentUser.getIdToken(true).then(token => {
        this.axios.post(this.$url.api + 'about/get/survey', {
          cid: this.$route.params.id
        }, {
          headers: {
            'firebase-token': token
          }
        }).then(res => {
          console.log(res)
          this.$set(this.config.status, 'loading', '')
          this.$emit('emit', {
            action: 'state',
            data: {
              type: 'loading',
              status: false
            }
          })
          if (res.data && res.data.success) {
            this.$set(this, 'store', res.data.data)
          }
        })
      })
    },
    prepare: function () {
      this.$refs.sex.prepare()
      this.$refs.birthday.prepare()
      this.$refs.notes.prepare()
      if (this.$refs.address) {
        for (let i = 0; i < this.$refs.address.length; i++) {
          this.$refs.address[i].prepare()
        }
      }
      if (this.$refs.contact) {
        for (let i = 0; i < this.$refs.contact.length; i++) {
          this.$refs.contact[i].prepare()
        }
      }
      if (this.$refs.travel) {
        for (let i = 0; i < this.$refs.travel.length; i++) {
          this.$refs.travel[i].prepare()
        }
      }
      if (this.$refs.lang) {
        for (let i = 0; i < this.$refs.lang.length; i++) {
          this.$refs.lang[i].prepare()
        }
      }
      if (this.$refs.cert) {
        for (let i = 0; i < this.$refs.cert.length; i++) {
          this.$refs.cert[i].prepare()
        }
      }
      if (this.$refs.jobs) {
        this.$refs.jobs.prepare()
      }
      if (this.$refs.goals) {
        this.$refs.goals.prepare()
      }
      if (this.$refs.locations) {
        this.$refs.locations.prepare()
      }
      if (this.$refs.time) {
        this.$refs.time.prepare()
      }
      if (this.$refs.stays) {
        this.$refs.stays.prepare()
      }
      if (this.$refs.lang) {
        this.$refs.lang.prepare()
      }
      if (this.$refs.preferences) {
        this.$refs.preferences.prepare()
      }
      if (this.$refs.budget) {
        this.$refs.budget.prepare()
      }
      if (this.$refs.knows) {
        this.$refs.knows.prepare()
      }
      if (this.$refs.wants) {
        this.$refs.wants.prepare()
      }
      this.edit()
    },
    edit: function (req) {
      const { id, type } = req || {}
      if (this.config.status.editing) {
        this.submit({ type: 'series' })
      }
      if (id) {
        this.$set(this.config.status, 'editing', id)
      } else if (type) {
        this.$set(this.config.status, 'editing', type)
      } else {
        this.$set(this.config.status, 'editing', 'all')
      }
      this.$emit('emit', {
        action: 'state',
        data: {
          type: 'editing',
          status: true
        }
      })
    },
    insert: function (req) {
      const { id, type, resolve } = req || {}
      if (id) {
        if (id.indexOf('addr_') >= 0 && this.store.addresses) {
          this.store.addresses.push(req)
          this.$nextTick(() => {
            if (this.$refs.address.length) {
              this.$refs.address[this.$refs.address.length - 1].prepare()
            }
          })
        } else if (id.indexOf('cont_') >= 0 && this.store.contacts) {
          this.store.contacts.push(req)
          this.$nextTick(() => {
            if (this.$refs.contact.length) {
              this.$refs.contact[this.$refs.contact.length - 1].prepare()
            }
          })
        }
      } else if (type && resolve) {
        if (this.store[type]) {
          this.store[type].push(resolve)
          this.$nextTick(() => {
            if (type === 'addresses') {
              this.$ref.address[this.$ref.address.length - 1].prepare()
            } else if (type === 'contacts') {
              this.$ref.contact[this.$ref.contact.length - 1].prepare()
            } else if (type === 'travels') {
              this.$ref.travel[this.$ref.travel.lenght - 1].prepare()
            } else if (type === 'certs') {
              this.$ref.cert[this.$ref.cert.length - 1].prepare()
            }
          })
        }
      }
    },
    remove: function (req) {
      if (
        req &&
        req.id &&
        req.type &&
        this.store[req.type] &&
        this.store[req.type].length
      ) {
        let idx = this.store[req.type].findIndex(it => {
          return it.id === req.id
        })
        if (idx >= 0) {
          this.store[req.type].splice(idx, 1)
        }
      }
    },
    preSubmit: function (req) {
      const { type } = req
      const urls = {
        update: `${this.$url.api}about/update/survey`,
        series: `${this.$url.api}about/update/survey`
      }
      if (this.$refs.form.validate()) {
        let fd = {
          cid: this.$route.params.id,
          addresses: [],
          contacts: [],
          travels: [],
          certs: []
        }
        if (['sex', 'all'].includes(this.config.status.editing)) {
          Object.assign(fd, this.$refs.sex.getForm())
        }
        if (['birthday', 'all'].includes(this.config.status.editing)) {
          Object.assign(fd, this.$refs.birthday.getForm())
        }
        if (['notes', 'all'].includes(this.config.status.editing)) {
          Object.assign(fd, this.$refs.notes.getForm())
        }
        if (['jobs', 'all'].includes(this.config.status.editing)) {
          Object.assign(fd, this.$refs.jobs.getForm())
        }
        if (['goals', 'all'].includes(this.config.status.editing)) {
          Object.assign(fd, this.$refs.goals.getForm())
        }
        if (['locations', 'all'].includes(this.config.status.editing)) {
          Object.assign(fd, this.$refs.locations.getForm())
        }
        if (['time', 'all'].includes(this.config.status.editing)) {
          Object.assign(fd, this.$refs.time.getForm())
        }
        if (['stays', 'all'].includes(this.config.status.editing)) {
          Object.assign(fd, this.$refs.stays.getForm())
        }
        if (['lang', 'all'].includes(this.config.status.editing)) {
          Object.assign(fd, this.$refs.lang.getForm())
        }
        if (['preferences', 'all'].includes(this.config.status.editing)) {
          Object.assign(fd, this.$refs.preferences.getForm())
        }
        if (['budget', 'all'].includes(this.config.status.editing)) {
          Object.assign(fd, this.$refs.budget.getForm())
        }
        if (['knows', 'all'].includes(this.config.status.editing)) {
          Object.assign(fd, this.$refs.knows.getForm())
        }
        if (['wants', 'all'].includes(this.config.status.editing)) {
          Object.assign(fd, this.$refs.wants.getForm())
        }
        if (this.config.status.editing === 'all') {
          if (this.$refs.address && this.$refs.address.length) {
            for (let i = 0; i < this.$refs.address.length; i++) {
              fd.addresses.push(this.$refs.address[i].getForm())
            }
          }
          if (this.$refs.contact && this.$refs.contact.length) {
            for (let i = 0; i < this.$refs.contact.length; i++) {
              fd.contacts.push(this.$refs.contact[i].getForm())
            }
          }
          if (this.$refs.travel && this.$refs.travel.length) {
            for (let i = 0; i < this.$refs.travel.length; i++) {
              fd.travels.push(this.$refs.travel[i].getForm())
            }
          }
          if (this.$refs.cert && this.$refs.cert.length) {
            for (let i = 0; i < this.$refs.cert.length; i++) {
              fd.certs.push(this.$refs.cert[i].getForm())
            }
          }
        }
        if (this.config.status.editing.indexOf('addr_') >= 0) {
          let idx = this.$refs.address.findIndex(it => {
            return it.isThisEditing
          })
          if (idx >= 0) {
            fd.addresses.push(this.$refs.address[idx].getForm())
          }
        }
        if (this.config.status.editing.indexOf('cont_') >= 0) {
          let idx = this.$refs.contact.findIndex(it => {
            return it.isThisEditing
          })
          if (idx >= 0) {
            fd.contacts.push(this.$refs.contact[idx].getForm())
          }
        }
        if (this.config.status.editing.indexOf('travel_') >= 0) {
          let idx = this.$refs.travel.findIndex(it => {
            return it.isThisEditing
          })
          if (idx >= 0) {
            fd.travels.push(this.$refs.travel[idx].getForm())
          }
        }
        if (this.config.status.editing.indexOf('cert_') >= 0) {
          let idx = this.$refs.cert.findIndex(it => {
            return it.isThisEditing
          })
          if (idx >= 0) {
            fd.certs.push(this.$refs.cert[idx].getForm())
          }
        }
        this.$emit('emit', {
          action: 'state',
          data: {
            type: 'loading',
            status: true
          }
        })
        if (type && urls[type]) {
          const url = urls[type]
          return { url, fd, type }
        }
      } else {
        return false
      }
    },
    submit: function (req) {
      const type = (req && req.type) ? req.type : 'update'
      const dt = this.preSubmit({ type })
      if (dt) {
        const { url, fd } = dt
        this.$firebase.auth().currentUser.getIdToken(true).then(token => {
          this.axios.post(url, fd, {
            headers: {
              'firebase-token': token
            }
          }).then(res => {
            console.log(res)
            if (res.data && res.data.success) {
              this.postSubmit({ type })
            } else {
              this.failSubmit()
            }
          }).catch(err => {
            console.log(err)
            this.failSubmit()
          })
        })
      }
    },
    postSubmit: function (req) {
      const { type } = req || {}
      if (type !== 'series') {
        this.$set(this.config.status, 'editing', '')
        this.$emit('emit', {
          action: 'state',
          data: {
            type: 'editing',
            status: false
          }
        })
      }
      this.$emit('emit', {
        action: 'state',
        data: {
          type: 'loading',
          status: false
        }
      })
      this.get(this.config.status.editing)
    },
    failSubmit: function () {
      this.$set(this.config.status, 'editing', '')
      this.$emit('emit', {
        action: 'state',
        data: {
          type: 'loading',
          status: false
        }
      })
      this.$emit('emit', {
        action: 'state',
        data: {
          type: 'editing',
          status: false
        }
      })
    },
    close: function () {
      this.$set(this.form, 'valid', true)
      this.$set(this.config.status, 'editing', '')
    },
    emitted: function (req) {
      if (req && req.action) {
        this[req.action](req.data)
      }
    }
  },
  computed: {
    isValid () {
      return this.form.valid
    },
    isEditing () {
      return this.config.status.editing
    },
    isAllEditing () {
      return this.config.status.editing === 'all'
    },
    isLoading () {
      return !!this.config.status.loading
    },
    isAllLoading () {
      return this.config.status.loading === 'all'
    },
    getStatus () {
      return this.config.status
    },
    getData () {
      return this.store
    },
    getAddressItems () {
      return (
        this.store.addresses
      ) ? this.store.addresses : []
    },
    getContactItems () {
      return (
        this.store.contacts
      ) ? this.store.contacts : []
    },
    getTravelItems () {
      return (
        this.store.travels
      ) ? this.store.travels : []
    },
    getCertItems () {
      return (
        this.store.certs
      ) ? this.store.certs : []
    }
  }
}
</script>

<style lang="scss">
#clientAboutSurvey {
}
</style>
